<template>
  <div class="Header">
    <div class="header w">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelectMenu"
        ref="menu"
        style="background: transparent !important; border-bottom: 0"
        :text-color="textColor"
        active-text-color="#ff6491"
        router
      >
        <router-link to="/" style="display: flex; align-items: center">
          <img src="@/assets/logo.png" alt="" width="60px" height="60px" />
          <h1 class="logo">享听音乐</h1>
        </router-link>
        <el-menu-item index="/home" class="menu-item"> 首页 </el-menu-item>
        <el-menu-item index="/mymusic/likes"  class="menu-item">我的音乐</el-menu-item>
        <el-menu-item index="/discover/playlist"  class="menu-item">歌单</el-menu-item>
        <el-menu-item index="/discover/artist"  class="menu-item">歌手</el-menu-item>
        <el-menu-item index="/toplist"  class="menu-item">排行榜</el-menu-item>
        <div class="right">
          <el-autocomplete
            v-model="state"
            popper-class="my-autocomplete"
            prefix-icon="el-icon-search"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
            @focus="loadHot"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.songName }}</div>
              <span class="addr">{{ item.singerName }}</span>
            </template>
          </el-autocomplete>
          <div class="btn-primary" v-if="!userInfo">
            <span @click="handleLogin" class="login_btn">登录</span> /
            <span @click="handleReg" class="reg_btn">注册</span>
          </div>
          <el-popover placement="bottom" trigger="hover" v-else>
            <ul class="dropdown-menu">
              <router-link to="/user"
                ><li class="dropdown-item">个人中心</li></router-link
              >
              <router-link to="/userinfo"
                ><li class="dropdown-item">账号设置</li></router-link
              >
              <li @click="logout" class="dropdown-item">退出登录</li>
            </ul>
            <div slot="reference" class="user-box">
              <el-image
                style="width: 100%; height: 100%"
                :src="userInfo.avatar"
                fit="cover"
              >
                <div slot="error" class="image-slot">
                  <img
                    src="@/assets/img-profile-head-default.png"
                    alt="头像"
                    width="100%"
                    height="100%"
                  />
                </div>
              </el-image>
            </div>
          </el-popover>
        </div>
      </el-menu>
    </div>
  </div>
</template>
<script>
import bus from "@/views/eventBus";
export default {
  props: {
    index: {
      default: "/",
      type: String,
    },
    textColor: {
      type: String,
    },
  },
  data() {
    return {
      activeIndex: this.index,
      restaurants: [],
      state: "",
      timeout: null,
      userInfo: null,
      queryParams: {
        pageNum: 1,
        pageSize: 5,
        type: "hot",
      },
    };
  },
  watch: {
    // 点击返回按钮，tab跟页面不对应
    $route: function (newVal, oldVal) {
      this.activeIndex = newVal.path;
    },
  },
  mounted() {
    // 页面刷新时定位到原导航
    this.activeIndex = this.$route.path;
    // console.log(this.$route, this.$refs.menu);
    this.getUserInfo();
  },
  methods: {
    handleSelectMenu(key, keyPath) {
      // console.log(key, keyPath);
    },
    // querySearch(queryString, cb) {
    //   var restaurants = this.restaurants;
    //   var results = queryString
    //     ? restaurants.filter(this.createFilter(queryString))
    //     : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return (restaurant) => {
    //     return (
    //       restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
    //       0
    //     );
    //   };
    // },
    async getUserInfo() {
      if (!sessionStorage.getItem("token")) return;
      const { data: res } = await this.$http.get("/user");
      if (res.code === 200) {
        // return this.$message.error('查询用户信息失败!')
        this.userInfo = res.data;
      }
    },
    async loadHot() {
      const { data: res } = await this.$http.get("/recommend/toplist", {
        params: this.queryParams,
      });
      if (res.code !== 200) return this.$message.error("搜索歌曲失败");
      this.restaurants = res.data;
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    handleLogin() {
      bus.$emit("show", true, "left");
    },
    handleReg() {
      bus.$emit("show", true, "right");
    },
    async querySearchAsync(queryString, cb) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      var restaurants = this.restaurants;
      if (queryString !== "") {
        const { data: res } = await this.$http.get("/query/comQuery/song", {
          params: { songName: queryString },
        });
        this.timeout = setTimeout(() => {
          cb(res.data);
        }, 2000);
      } else {
          cb(restaurants);
      }
      // var results = queryString
      //   ? restaurants.filter(this.createStateFilter(queryString))
      //   : restaurants;
      // if (!res.length) {
      //   res = [{ songName: "无匹配数据" }];
      // }
      // if (queryString === "") {
      //   res = this.restaurants;
      // }
      // clearTimeout(this.timeout);
      // this.timeout = setTimeout(() => {
      //   cb(res.data);
      // }, 2000);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.songName.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0 ||
          state.singerName.toLowerCase().indexOf(queryString.toLowerCase()) ===
            0
        );
      };
    },
    songDetail(id) {
      this.$router.push({
        path: "/songdetails",
        //传参
        query: {
          id: id,
        },
      });
    },
    handleSelect(item) {
      this.songDetail(item.m_id);
    },
    logout() {
      this.userInfo = null;
      window.sessionStorage.clear();
      bus.$emit("show", true);
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="scss">
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
.Header {
  width: 100%;
  background: #fff;
  margin-bottom: 15px;
  z-index: 99;
}
.header {
  // width: 1200px;
  margin: 0px auto;
  .logo {
    color: #ff6491;
    margin-right: 20px;
  }
  .el-menu {
    display: flex;
    align-items: center;
  }
  .right {
    flex-grow: 1;
    display: flex;
    justify-content: right;
    align-items: center;
  }
  ::v-deep .el-autocomplete .el-input__inner {
    border-radius: 40px;
    background: #fdfdfd;
  }
  .btn-primary {
    margin-left: 10px;
    padding: 10px 20px;
    color: #fff;
    border-radius: 20px;
    background: linear-gradient(to bottom right, #ff6491, #ffc19f);
    .login_btn,
    .reg_btn {
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
    .login_btn:hover,
    .reg_btn:hover {
      color: #ffb7cd;
    }
  }
}
.user-box {
  margin-left: 20px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}

.el-input {
  height: 10px;
  border-radius: 40px;
}
</style>